import { AfterViewInit, Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { HeightRatioService } from '@shared/directives/height-ratio.service';
import { componentDestroyed, UntilDestroy } from '@mtgame/core';
import { takeUntil } from 'rxjs/operators';

@UntilDestroy
@Directive({
  selector: '[mtgHeightRatio]'
})
export class HeightRatioDirective implements OnInit, OnDestroy, AfterViewInit {
  @Input('mtgHeightRatio')
  ratio: number;

  constructor(
    private heightRatioService: HeightRatioService,
    private elementRef: ElementRef,
  ) {
  }

  ngOnInit(): void {
    this.heightRatioService.windowResized$
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(() => {
        this.updateHeight();
      });
  }

  ngOnDestroy(): void {
  }

  ngAfterViewInit(): void {
    this.updateHeight();
  }

  updateHeight(): void {
    const width = this.elementRef.nativeElement.clientWidth;
    const height = width / this.ratio;
    this.elementRef.nativeElement.style.height = `${height}px`;
  }
}
